(function () {
    "use strict";

    // Standard DOM Event for Swiper
    document.addEventListener('init_carousel', function (e) {
        if (typeof Swiper === 'undefined') return;
        const el = e.target;
        if (!el.classList || !el.matches('.swiper[data-settings]')) return;

        if (el.classList.contains('swiper-initialized')) {
            return;
        }

        let swiper_settings = el.getAttribute('data-settings');
        try {
            swiper_settings = JSON.parse(swiper_settings);
        } catch (err) {
            swiper_settings = {};
        }

        // Scope navigation elements to prevent conflict between multiple sliders
        if (swiper_settings.navigation) {
            if (swiper_settings.navigation.nextEl && typeof swiper_settings.navigation.nextEl === 'string') {
                const nextNode = el.querySelector(swiper_settings.navigation.nextEl) || (el.parentElement ? el.parentElement.querySelector(swiper_settings.navigation.nextEl) : null);
                if (nextNode) {
                    swiper_settings.navigation.nextEl = nextNode;
                }
            }
            if (swiper_settings.navigation.prevEl && typeof swiper_settings.navigation.prevEl === 'string') {
                const prevNode = el.querySelector(swiper_settings.navigation.prevEl) || (el.parentElement ? el.parentElement.querySelector(swiper_settings.navigation.prevEl) : null);
                if (prevNode) {
                    swiper_settings.navigation.prevEl = prevNode;
                }
            }
        }
        if (swiper_settings.pagination) {
            if (swiper_settings.pagination.el && typeof swiper_settings.pagination.el === 'string') {
                const pagNode = el.querySelector(swiper_settings.pagination.el) || (el.parentElement ? el.parentElement.querySelector(swiper_settings.pagination.el) : null);
                if (pagNode) {
                    swiper_settings.pagination.el = pagNode;
                }
            }
        }
        if (swiper_settings.scrollbar) {
            if (swiper_settings.scrollbar.el && typeof swiper_settings.scrollbar.el === 'string') {
                const scrollNode = el.querySelector(swiper_settings.scrollbar.el) || (el.parentElement ? el.parentElement.querySelector(swiper_settings.scrollbar.el) : null);
                if (scrollNode) {
                    swiper_settings.scrollbar.el = scrollNode;
                }
            }
        }

        const swiper = new Swiper(el, swiper_settings);
        el.swiper = swiper;
        if (window.jQuery) {
            window.jQuery(el).data('swiper', swiper);
        }

    });


    const initSwipers = () => {
        document.querySelectorAll('.swiper[data-settings]').forEach(el => {
            el.dispatchEvent(new CustomEvent('init_carousel', {bubbles: true}));
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSwipers);
    } else {
        initSwipers();
    }

})();
